import { PublicTourPriceWebDto } from '@/features/public/booking/types/BookingTourBasicDataDto.ts';

export const requiresAgeValidation = (
  prices: PublicTourPriceWebDto[] | null,
): boolean => {
  if (!prices || prices.length === 0) return false;
  return prices.every((p) => p.ageRestriction !== null);
};

export const isAgeWithinAnyRange = (
  age: number,
  prices: PublicTourPriceWebDto[],
): boolean => {
  return prices.some((p) => {
    const restriction = p.ageRestriction;
    if (!restriction) return true;

    const aboveMin = restriction.minAge == null || age >= restriction.minAge;
    const belowMax = restriction.maxAge == null || age <= restriction.maxAge;
    return aboveMin && belowMax;
  });
};

const formatAgeRestrictionLabel = (
  restriction: { minAge?: number; maxAge?: number } | null,
): string => {
  if (!restriction) return '';
  if (restriction.minAge && restriction.maxAge) {
    return `${restriction.minAge}-${restriction.maxAge} lat`;
  }
  if (restriction.minAge) {
    return `${restriction.minAge}+ lat`;
  }
  if (restriction.maxAge) {
    return `do ${restriction.maxAge} lat`;
  }
  return '';
};

export const formatAgeRangesErrorMessage = (
  prices: PublicTourPriceWebDto[],
): string => {
  const ranges = prices
    .map((p) => formatAgeRestrictionLabel(p.ageRestriction))
    .filter(Boolean);

  return `Wiek uczestnika nie mieści się w żadnym z dozwolonych przedziałów: ${ranges.join(', ')}`;
};
